import { ADDRESS_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/AddressStep/constants';
import { JOIN_NOW_NEW_USER_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/JoinNowStep/components/JoinNowNewUser/constants';
import { PREFERENCES_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/common/steps/PreferencesStep/constants';
import { PERSONAL_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/registration/steps/PersonalStep/constants';
import { SECURITY_STEP_DATA } from '@interlayer/js/app/components/main/Registration/components/templates/OnlineReg/components/RegInSteps/components/registration/steps/SecurityStep/constants';
import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';
import { STEP_NAMES } from '@interlayer/js/app/store/reducers/Registration/constants';

import { TRegistrationData, TRegistrationSteps } from './types';

export const REGISTRATION_DATA: TRegistrationData = {
    [STEP_NAMES.JOIN_STEP]: JOIN_NOW_NEW_USER_DATA,
    [STEP_NAMES.PERSONAL_STEP]: PERSONAL_DATA,
    [STEP_NAMES.SECURITY_STEP]: SECURITY_STEP_DATA,
    [STEP_NAMES.ADDRESS_STEP]: ADDRESS_DATA,
    [STEP_NAMES.PREFERENCES_STEP]: {
        ...PREFERENCES_DATA,
        [VALIDATION_FIELDS.terms]: false
    }
};

export const REGISTRATION_ORDERED_STEPS: TRegistrationSteps[] = [
    STEP_NAMES.JOIN_STEP,
    STEP_NAMES.PERSONAL_STEP,
    STEP_NAMES.SECURITY_STEP,
    STEP_NAMES.ADDRESS_STEP,
    STEP_NAMES.PREFERENCES_STEP
];

export const REGISTRATION_ORDERED_OBJECT_STEPS = REGISTRATION_ORDERED_STEPS.reduce((acc, stepName, index) => ({
    ...acc,
    [stepName]: index
}), {} as Record<TRegistrationSteps, number>);
